module.exports = __webpack_public_path__ + "static/media/ici.0fc3f2c867a33d3d9157589dff06aaa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ici.png
// module id = 2662
// module chunks = 1